import { useState, useCallback } from 'react';

interface Message {
  id: string;
  sender: 'user' | 'bot';
  text: string;
  timestamp: string;
  isConsentRequest?: boolean;
}

interface ChatPayload {
  message: string;
  isAuthenticated: boolean;
  userEmail?: string;
}

export const useChatBot = (isAuthenticated: boolean, userEmail: string | null) => {
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = useCallback(
    async (messageWithContext: string): Promise<{ message: string; isFeedback?: boolean } | null> => {
      setIsLoading(true);
      try {
        const payload: ChatPayload = {
          message: messageWithContext,
          isAuthenticated: isAuthenticated || false,
        };

        if (isAuthenticated && userEmail) {
          payload.userEmail = userEmail;
        }

        const response = await fetch(`${process.env.REACT_APP_CHATBOT_API_URL}/chatbot`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('Network error');

        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error sending message:', error);
        throw error;
      } finally {
        setIsLoading(false);
      }
    },
    [isAuthenticated, userEmail]
  );

  return {
    isLoading,
    sendMessage,
  };
};
